import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './AlgorithmFilterClause.translations.json';
import React, { FC, MouseEventHandler } from 'react';
import { AlgorithmCondition } from '../algorithmCondition/AlgorithmCondition';
import { useGetAlgorithmMappingsQuery } from '../mappings/query/useGetAlgorithmMappingsQuery';
import { useGetAlgorithmFilterClauseQuery } from './query/useGetAlgorithmFilterClauseQuery';
import { AlgorithmHeader } from '../AlgorithmHeader';

const { addTranslations, useTranslation } = i18nNsFactory(
  'algorithm-filter-clause',
);
addTranslations(translations);

export interface AlgorithmFilterClauseProps {
  algorithmId: number;
  onEditButtonClick?: MouseEventHandler<HTMLButtonElement>;
  expanded?: boolean;
  onToggle?: (expanded: boolean) => void;
  hasError?: boolean;
  isLoading?: boolean;
}

export const AlgorithmFilterClause: FC<AlgorithmFilterClauseProps> = (
  props,
) => {
  const { algorithmId, isLoading, ...rest } = props;
  const { t } = useTranslation();

  const { data: algorithmFilterClause, isLoading: isLoadingFilterClause } =
    useGetAlgorithmFilterClauseQuery({
      id: algorithmId,
    });

  const { data: algorithmMappings, isLoading: isLoadingMappings } =
    useGetAlgorithmMappingsQuery({
      id: algorithmId,
    });

  return (
    <AlgorithmHeader
      algorithmId={algorithmId}
      id="algorithm-filter-clause"
      title={t('title')}
      isLoading={
        isLoading || isLoadingFilterClause || isLoadingMappings
          ? 'manage'
          : undefined
      }
      hideExpand={!algorithmFilterClause?.filterClause}
      {...rest}
    >
      <AlgorithmCondition
        condition={algorithmFilterClause?.filterClause || ''}
        mappings={algorithmMappings?.mappings || []}
      />
    </AlgorithmHeader>
  );
};
